module.exports = __webpack_public_path__ + "media/assets/images/logo-movimenta-750f8a547ad29056400d47f61addeaec.svg";